import { createContext, useContext } from 'react'

export type TranslateFn = (
	key: string,
	defaultMessage: string | undefined
) => string

interface I18nContextType {
	translate: TranslateFn
}

export const I18nContext = createContext<I18nContextType>({
	translate: (_key, defaultMessage) => defaultMessage ?? '',
})

export const useI18n = () => useContext(I18nContext)
